import { SUPERUSER_ROLES } from '../utils/roles';

// Niveles de acceso especiales (además de una lista explícita de roles):
export const PUBLIC = 'PUBLIC'; // sin restricción (páginas libres)
export const AUTH = 'AUTH'; //   cualquier usuario autenticado

// Mapa vista(routeId) -> acceso, derivado de nova_vistas_roles_privilegios.xlsx.
// Los ids coinciden con routeList.js / menuItemFilter.
//
// ⚠️ Los strings de rol son los CANÓNICOS del JWT, no las etiquetas del Excel.
//    En particular 'Planeacion' va SIN tilde (ConstantesRoles.EsPlaneacion).
//    Los contenedores usan la unión de roles de sus hijos.
//    Vistas ausentes del mapa (p.ej. 'inventarios', 'build-info') quedan sin
//    restricción de rol: solo las gobierna su flag REACT_APP_ALLOW_*.
export const viewPermissions = {
    home: AUTH,
    monitoreo: AUTH,
    machineLearning: AUTH,

    reportes: ['Administrador', 'Reportes'],

    ordenes: ['Administrador', 'Planeacion'],
    'ordenes-lista': ['Administrador', 'Planeacion'],
    'ordenes-calendario': ['Administrador', 'Planeacion'],

    productos: ['Administrador', 'Planeacion'],

    alertas: ['Administrador', 'Supervisor', 'Calidad', 'Planeacion'], // unión de hijos
    'alertas-fallas': ['Administrador', 'Supervisor', 'Planeacion'],
    'alertas-llamadas': ['Administrador', 'Supervisor', 'Planeacion'],
    'alertas-noprod': ['Administrador', 'Supervisor', 'Planeacion'],
    'alertas-calidad': ['Administrador', 'Calidad', 'Planeacion'],
    'alertas-parosautorizados': ['Administrador', 'Supervisor', 'Planeacion'],

    parametros: ['Administrador', 'Planeacion'], // unión de hijos
    'parametros-ritmo': ['Administrador'],
    'parametros-turnos': ['Administrador', 'Planeacion'],
    'parametros-capacidad': ['Administrador', 'Planeacion'],
    'parametros-festivos': ['Administrador', 'Planeacion'],

    usuarios: ['Administrador'],

    config: AUTH, // config-cuenta es AUTH, así que el contenedor también
    'config-cuenta': AUTH,
    'config-telegram': ['Administrador'],
};

// ¿El conjunto de roles del usuario puede acceder a la vista viewId?
export function canAccessView(viewId, roles = []) {
    const rule = viewPermissions[viewId];
    if (rule === undefined) return true; // no listada -> solo la gobierna el flag
    if (rule === PUBLIC || rule === AUTH) return true; // basta con estar autenticado
    if (roles.some((r) => SUPERUSER_ROLES.includes(r))) return true; // superusuarios ven todo
    return roles.some((r) => rule.includes(r));
}
